export const handleCurrency = (amount: number, currency: string, language: string) => {
    return amount.toLocaleString(language, {
        style: 'currency',
        currency,
    });
};
